module.exports = __webpack_public_path__ + "static/media/Icons_arrow.6550a90b.svg";